export default __webpack_public_path__ + "static/media/gbc.49954a4f.png";